import {RootState} from "../../../store";

export const getNavbarShow = (state: RootState) => state.navbarReducer.isShowNavbar;
